<template>
  <div class="cpunk_page" style="position: relative">
    <div class="suggest-list">
      <img class="content" src="~@static/funding_cpunk/tip1.png" />
    </div>
    <div class="more-btn" @click="bindToMoreTips"></div>
    <div class="create_btn_s1" v-if="noLogin" @click="toLogin"># 立即开造 #</div>
    <div v-else class="create_btn_s1" @click="bindToBegin"># 现在就开造 #</div>
    <div style="height: 50px"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { behavior } from '@/utils/behavior'

export default {
  name: '',
  data() {
    return {}
  },
  computed: {
    ...mapState(['authorization']),
    noLogin() {
      return !this.authorization || this.authorization == ''
    },
  },
  methods: {
    bindToBegin() {
      this.$router.push({ path: '/fundingnew/creation/step1', query: this.$route.query })
      _jcq.push(['_track', 'yjhbccreate'])
      behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc5' })
    },
    bindToMoreTips() {
      this.$router.push({ path: '/fundingnew/more_tips', query: this.$route.query })
      _jcq.push(['_track', 'yjhbctip_more'])
      behavior({ behavior_code: 'prc_bhv_abs_bcyjh_bc14' })
    },
    toLogin() {
      this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@styles/cpunk.scss';
.cpunk_page {
  padding-top: pxtow(164);
  padding-bottom: pxtow(100);
}
.suggest-list {
  position: relative;
}
.suggest-list .content {
  display: block;
  width: pxtow(669);
  margin: 0 auto;
}

.more-btn {
  width: pxtow(650);
  height: pxtow(65);
  position: absolute;
  top: pxtow(970);
  left: pxtow(50);
}

.create_btn_s1 {
  margin-top: pxtow(56) !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/fundingnew/creation/Creation.vue